import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import { LazyLoadImage, LazyLoadSource } from 'ck-ui';
import { getSanityImg } from 'src/sanityClient';
import { getPromoName, trackPromotionClick } from '../utils';
import { usePromotionView } from '../hooks';
import { ConsentPopup } from '../../NewsLetter/ConsentPopup';

const Consent = ({
  blockConsent,
  handle,
  position,
}) => {
  const {
    campaignId,
    desktopImage,
    mobileImage,
    popupTitle,
    popupDescription,
    popupHeroImage,
    popupGiftImage,
    popupSuccessTitle,
    popupSuccessDescription,
    popupLegalDocUrl,
    title,
    trackingID
  } = blockConsent;
  const [show, setShow] = useState(false);
  const isMobile = useMedia('(max-width: 767px)');
  const ref = useRef(null);
  const desktopImgUrl = getSanityImg(desktopImage).url();
  const mobileImgUrl = getSanityImg(mobileImage).url();
  const onClose = () => setShow(false);
  const promo = {
    id: handle,
    name: getPromoName(handle, trackingID || title),
    creative: isMobile ? mobileImgUrl : desktopImgUrl,
    position: `${handle}-${position}`
  };

  usePromotionView([promo], ref);
  return (
    <section ref={ref} className="home-section">
      <div className="container">
        <div className="columns">
          <div className="column">
            <a
              className="home-promo-single image-wrapper"
              href={null}
              onClick={
                () => {
                  if (!show) trackPromotionClick(promo);
                  setShow(true);
                }
              }
            >
              <picture>
                <LazyLoadSource
                  media="(max-width: 767px)"
                  srcSet={mobileImgUrl}
                />
                <LazyLoadSource
                  media="(min-width: 768px)"
                  srcSet={desktopImgUrl}
                />
                <LazyLoadImage
                  src={desktopImgUrl}
                  alt={title}
                />
              </picture>
            </a>
          </div>
        </div>
      </div>

      <ConsentPopup
        show={show}
        campaignId={campaignId}
        heroImage={getSanityImg(popupHeroImage).width(600).url()}
        giftImage={getSanityImg(popupGiftImage).width(600).url()}
        heading={popupTitle}
        content={popupDescription}
        successHeading={popupSuccessTitle}
        successContent={popupSuccessDescription}
        legalDocUrl={popupLegalDocUrl} // don't need this but don't need to clean up since we move to hydrogen soon
        onClose={onClose}
      />
    </section>
  );
};

Consent.propTypes = {
  blockConsent: PropTypes.object.isRequired,
  handle: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
};

export { Consent };
